import * as React from 'react'

import DialogLayout from './dialog-layout/dialog-layout.component'

const Dialog = (props) => {
  return <DialogLayout {...props} />
}

export default Dialog
